import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "@/lib/api";

// items: [{ label, to }] — last item is current (no link)
export default function Breadcrumbs({ items }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: `${SITE_URL}${it.to || ""}`,
    })),
  };
  return (
    <nav aria-label="Breadcrumb" className="text-sm" data-testid="breadcrumbs">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ol className="flex flex-wrap items-center gap-1 text-slate-500">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-slate-400" />}
            {it.to && i < items.length - 1 ? (
              <Link to={it.to} className="hover:text-navy transition-colors">{it.label}</Link>
            ) : (
              <span className="text-slate-700 font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
